import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentState } from './document.reducer';

export const selectDataState = createFeatureSelector<DocumentState>('Document');

export const getDocumentData = createSelector(
  selectDataState,
  (state: DocumentState) => state
);
export const getLoadingState = createSelector(
  selectDataState,
  (state: DocumentState) => state.isLoading
);

export const getDeletedStatus = createSelector(
  selectDataState,
  (state: DocumentState) => state.isDeleted
);

export const getLoadError = createSelector(
  selectDataState,
  (state: DocumentState) => state.loadError
);
export const getDeleteError = createSelector(
  selectDataState,
  (state: DocumentState) => state.deleteError
);
export const getAddEditError = createSelector(
  selectDataState,
  (state: DocumentState) => state.addEditError
);
